import styled, { keyframes } from 'styled-components';

const glowPulse = keyframes`
  0%, 100% {
    filter: drop-shadow(0 0 20px rgba(255, 68, 68, 0.6))
            drop-shadow(0 0 40px rgba(255, 68, 68, 0.4))
            drop-shadow(0 0 60px rgba(255, 68, 68, 0.2));
    transform: scale(1);
  }
  50% {
    filter: drop-shadow(0 0 30px rgba(255, 68, 68, 0.8))
            drop-shadow(0 0 60px rgba(255, 68, 68, 0.6))
            drop-shadow(0 0 90px rgba(255, 68, 68, 0.3));
    transform: scale(1.05);
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
`;

export const CTASection = styled.section<{ $isVisible?: boolean }>`
  padding: 160px 0 0;
  text-align: center;
  background: linear-gradient(180deg, rgba(255, 68, 68, 0.05) 0%, rgba(10, 10, 10, 1) 100%);
  position: relative;
  overflow: visible;
  margin-top: 0;

  @media (max-width: 768px) {
    padding: 140px 0 0;
    margin-top: 0;
  }
`;

export const LoopraLogo = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 160px;
  height: 160px;
  animation: ${glowPulse} 3s ease-in-out infinite, ${float} 4s ease-in-out infinite;
  will-change: transform, filter;
  pointer-events: none;
  z-index: 20;

  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
    top: 10px;
  }
`;
